module.exports = __webpack_public_path__ + "static/media/2_3.5f254313.png";